import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import * as styles from "./InvoiceFooterStyles";
import { InvoiceDataType } from "../../api/invoice";

const SignaturesSection: React.FC<{ sellerName?: string }> = ({
  sellerName,
}) => (
  <TableRow style={styles.rowBorderStyle}>
    <TableCell sx={styles.signaturesLeftCell}>
      Receivers Seal & Signature
    </TableCell>
    <TableCell sx={styles.signaturesRightCell}>For {sellerName}</TableCell>
  </TableRow>
);

export const EmptyRow: React.FC = () => (
  <TableRow>
    <TableCell sx={styles.emptyRowCell} />
    <TableCell sx={styles.emptyRowCellRight}>
      {/* Signature Image with Proper Alignment */}
    </TableCell>
  </TableRow>
);

interface InvoiceFooterProps {
  showSignaturesOnly?: boolean;
  data?: InvoiceDataType;
}

const InvoiceFooter: React.FC<InvoiceFooterProps> = ({
  showSignaturesOnly = false,
  data,
}) => {
  const sellerName = data?.seller_details?.name ?? data?.company?.name ?? "";
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          <SignaturesSection sellerName={sellerName} />
          <EmptyRow />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceFooter;
